import React, { useCallback } from 'react'
import MerchDutyForm from '@EUForms/invoice/merchDutyForm'
import { useSelector } from 'react-redux'
import { selectTaxTypeList } from '@EUForms/selectors'
import List from '@commonComponents/List'

const MerchandiseDutyDetail = ({ dataSource, ...rest }) => {
  const costTypeList = useSelector(selectTaxTypeList)
  const renderItem = useCallback(
    (item) => (
      <MerchDutyForm dataSource={item} key={item.id} dropdownList={costTypeList} {...rest} />
    ),
    [rest, costTypeList]
  )
  return (
      <List className='responsiveGridCss' dataSource={dataSource} renderItem={renderItem} />
  )
}

export default React.memo(MerchandiseDutyDetail)
